import React from 'react';
import ReactSkeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

const Skeleton = ({
  baseColor = '#E9EAEB',
  highlight = '#FDFDFD',
  height = '52px',
  count = 1,
  containerClassName,
  containerStyle,
  ...rest
}) => {
  return (
    <SkeletonTheme highlightColor={highlight} baseColor={baseColor}>
      <ReactSkeleton
        className="skeleton"
        height={height}
        count={count}
        duration={1.4}
        borderRadius="0.5rem"
        containerClassName={containerClassName}
        containerStyle={containerStyle}
        {...rest}
      />
    </SkeletonTheme>
  );
};

export default Skeleton;
